import { User } from '../models/user.model';

export type AuthStep = 'credentials' | 'two-factor';

export interface ICoreState {
  user: User | null;
  token: string | null;
  sidenavOpened: boolean;
  appVersion: string;
  authStep: AuthStep;
  authError: string | null;
  pendingUsername: string | null;
  // Ciphertext RSA-OAEP do usuário (passo 1) — reaproveitado tal e qual no
  // passo 2, ver comentário em auth.model.ts (TwoFactorValidationRequest).
  pendingEncryptedUser: string | null;
  // Token intermediário retornado por Auth/Credentials — vai no header
  // Authorization de Auth/2FA/Validate.
  pendingIntermediateToken: string | null;
  pendingUserCode: string | null;
}

export const initialCoreState: ICoreState = {
  user: null,
  token: null,
  sidenavOpened: true,
  appVersion: '0.0.0',
  authStep: 'credentials',
  authError: null,
  pendingUsername: null,
  pendingEncryptedUser: null,
  pendingIntermediateToken: null,
  pendingUserCode: null,
};

export interface IAppState {
  core: ICoreState;
}
